export default "/profile/images/whatsapp.svg?26937f84b350b869367099e18cf92724";